import { useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeProvider';
import { Home } from './pages/Home';
import { Exhibition } from './pages/Exhibition';
import { Login } from './pages/Login';
import { Tutorial } from './pages/Tutorial';
import { Roster } from './pages/Roster';
import { MemberDetail } from './pages/MemberDetail';
import { Gacha } from './pages/Gacha';
import { Campaign } from './pages/Campaign';
import { PreBattle } from './pages/PreBattle';
import { BattlePage } from './pages/BattlePage';
import { DailyChallenge } from './pages/DailyChallenge';
import { Ladder } from './pages/Ladder';
import { Friends } from './pages/Friends';
import { Replay } from './pages/Replay';
import { Settings } from './pages/Settings';
import { usePlayerStore } from './store/player';
import { syncToken } from './auth/panor';
import { api } from './api/client';
import { RequireAuth } from './auth/RequireAuth';

export function App() {
  const setBackendAvailable = usePlayerStore(s => s.setBackendAvailable);
  const setMe = usePlayerStore(s => s.setMe);
  const setAuthStatus = usePlayerStore(s => s.setAuthStatus);

  useEffect(() => {
    fetch('/stanwars/api/health')
      .then(r => { setBackendAvailable(r.ok); })
      .catch(() => { setBackendAvailable(false); });
  }, [setBackendAvailable]);

  useEffect(() => {
    if (syncToken()) {
      api.me.get()
        .then(setMe)
        .catch(() => setAuthStatus('anonymous'));
    } else {
      setAuthStatus('anonymous');
    }
  }, [setMe, setAuthStatus]);

  return (
    <ThemeProvider>
      <HashRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/exhibition" element={<Exhibition />} />
          <Route path="/login" element={<Login />} />
          <Route path="/tutorial" element={<Tutorial />} />

          {/* Game routes — gated by RequireAuth so hard-refresh doesn't bounce to /login during auth restore */}
          <Route path="/roster" element={<RequireAuth><Roster /></RequireAuth>} />
          <Route path="/member/:memberId" element={<RequireAuth><MemberDetail /></RequireAuth>} />
          <Route path="/gacha" element={<RequireAuth><Gacha /></RequireAuth>} />
          <Route path="/campaign" element={<RequireAuth><Campaign /></RequireAuth>} />
          <Route path="/campaign/stage/:stageId" element={<RequireAuth><PreBattle /></RequireAuth>} />
          <Route path="/daily" element={<RequireAuth><DailyChallenge /></RequireAuth>} />
          <Route path="/daily/today" element={<RequireAuth><PreBattle /></RequireAuth>} />
          <Route path="/ladder" element={<RequireAuth><Ladder /></RequireAuth>} />
          <Route path="/ladder/play" element={<RequireAuth><PreBattle /></RequireAuth>} />
          <Route path="/friends" element={<RequireAuth><Friends /></RequireAuth>} />
          <Route path="/friend/play/:code" element={<RequireAuth><PreBattle /></RequireAuth>} />
          <Route path="/battle/:matchId" element={<RequireAuth><BattlePage /></RequireAuth>} />
          <Route path="/replay/:id" element={<Replay />} />
          <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
        </Routes>
      </HashRouter>
    </ThemeProvider>
  );
}
